// src/app/pages/newsroom/newsroom.component.ts

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PressReleaseListComponent } from '../press-release-list/press-release-list.component';
import { NewsletterSignupComponent } from '../newsletter-signup/newsletter-signup.component';
import { PressReleaseFormComponent } from '../press-release-form/press-release-form.component';

import { PressReleaseService } from '../services/press-release.service';
import { createPressReleaseSlug, PressRelease } from '../models/press-release';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-newsroom',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    PressReleaseListComponent,
    NewsletterSignupComponent,
    PressReleaseFormComponent
  ],
  templateUrl: './newsroom.component.html',
  styleUrls: ['./newsroom.component.css']
})
export class NewsroomComponent implements OnInit {

  isAuthenticated = false; // Placeholder for auth logic

  constructor(
    private seo: SeoService,
    private pressReleaseService: PressReleaseService
  ) {}

  ngOnInit(): void {

    this.seo.update(
      'Newsroom',
      'Official newsroom for Lydia Christensen and her campaign for the United States Senate. Read campaign news, press releases, announcements, and updates.',
      'newsroom'
    );

    this.pressReleaseService.getPressReleases().subscribe({
      next: (releases: PressRelease[]) => {

        const hasPart = releases.map((release) => ({
          "@type": "NewsArticle",
          "@id": `https://www.lydialynnchristensen.com/newsroom/${createPressReleaseSlug(release)}#article`,
          "url": `https://www.lydialynnchristensen.com/newsroom/${createPressReleaseSlug(release)}`,
          "headline": release.title,
          "description": release.summary,
          "datePublished": release.date.toISOString(),

          "author": {
            "@id": this.seo.lydiaId
          },

          "publisher": {
            "@id": this.seo.campaignId
          },

          "about": {
            "@id": this.seo.lydiaId
          },

          "isPartOf": {
            "@id": "https://www.lydialynnchristensen.com/newsroom#collection"
          }
        }));

        this.seo.setStructuredData({
          "@context": "https://schema.org",
          "@graph": [

            {
              "@type": "CollectionPage",
              "@id": "https://www.lydialynnchristensen.com/newsroom#collection",
              "url": "https://www.lydialynnchristensen.com/newsroom",
              "name": "Lydia Christensen Newsroom",
              "description": "Official newsroom for Lydia Christensen and her campaign for the United States Senate.",

              "isPartOf": {
                "@id": this.seo.websiteId
              },

              "about": {
                "@id": this.seo.lydiaId
              },

              "publisher": {
                "@id": this.seo.campaignId
              },

              "hasPart": hasPart
            }

          ]
        });
      },

      error: (error) => {
        console.error('Error loading press releases for structured data:', error);

        // Still provide valid newsroom-level structured data
        // if the release list cannot be loaded.
        this.seo.setStructuredData({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "@id": "https://www.lydialynnchristensen.com/newsroom#collection",
          "url": "https://www.lydialynnchristensen.com/newsroom",
          "name": "Lydia Christensen Newsroom",
          "description": "Official newsroom for Lydia Christensen and her campaign for the United States Senate.",

          "isPartOf": {
            "@id": this.seo.websiteId
          },

          "about": {
            "@id": this.seo.lydiaId
          },

          "publisher": {
            "@id": this.seo.campaignId
          }
        });
      }
    });
  }
}
